import "./tab1.scss";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import * as React from "react";
import {useState} from "react";
import GoalType, {IGoalType} from "../../../../../ui/goaltype/goaltype";
import AutoComplete from "../../../../../ui/autocomplete/autocomplete";
import {autoCompleteItem} from "../../../../../modals/types/autocomplete";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";

const Tab1 = () => {
    return (
        <div className="Tab1">

        </div>
    );
}

export default Tab1;